import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ListingPhoto } from './types/Listing';

export default (makeCall: MakeCall) => (listingId: number, photoId: number) =>
  makeCall<ListingPhoto[]>(
    'PUT',
    `/api/v2/listing/${listingId}/photo/${photoId}/confirm`,
  );
